/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_GymInputs */

const en_homepage_listen_in_gym = /** @type {(inputs: Homepage_Listen_In_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Gym`)
};

const es_homepage_listen_in_gym = /** @type {(inputs: Homepage_Listen_In_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el gimnasio`)
};

/**
* | output |
* | --- |
* | "The Gym" |
*
* @param {Homepage_Listen_In_GymInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_gym = /** @type {((inputs?: Homepage_Listen_In_GymInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_GymInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_gym(inputs)
	return en_homepage_listen_in_gym(inputs)
});